module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_8004.2ccba535.png";